import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { File } from '@appbolaget/aware-model';
import { MediaDialogService } from '@components/media/media-dialog.service';
import { SecureImagePipe } from '@helpers/pipes';
import { SnackbarService } from '@viewservices/snackbar.service';
import { filter, take } from 'rxjs';

@Component({
    selector: 'aw-single-file-picker',
    templateUrl: 'single-file-picker.component.html',
    standalone: true,
    imports: [NgIf, MatIconModule, SecureImagePipe, MatButtonModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SingleFilePickerComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: SingleFilePickerComponent,
        },
    ],
})
export class SingleFilePickerComponent implements ControlValueAccessor, Validator, OnInit {
    value: File;
    touched = false;
    disabled = false;

    onChange = (_) => {};
    onTouched = () => {};

    @Input() required = false;
    @Input() infoText: string;

    constructor(
        private mediaDialogService: MediaDialogService,
        private snackbarService: SnackbarService,
    ) {}

    ngOnInit() {}

    validate(_: AbstractControl): ValidationErrors | null {
        if (this.required && !this.value) {
            return { required: true };
        }

        return null;
    }

    writeValue(file: File): void {
        this.value = file;
    }

    registerOnChange(onChange: any): void {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any): void {
        this.onTouched = onTouched;
    }

    setDisabledState?(disabled: boolean) {
        this.disabled = disabled;

        if (disabled) {
            // this.passwordControl.disable();
        } else {
            // this.passwordControl.enable();
        }
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    async openFilePicker() {
        const options = {
            multiple: false,
        };

        const dialog = await this.mediaDialogService.open(true, options);

        dialog
            .afterClosed()
            .pipe(
                take(1),
                filter((file) => !!file),
            )
            .subscribe((file?: File) => {
                if (!file.isImage() && file.mime !== 'application/pdf') {
                    return this.snackbarService.error('Endast bilder eller pdf-filer tillåts');
                }
                this.value = file;
                this.markAsTouched();
                this.onChange(file);
            });
    }
}
